
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/win-a-yacht-holiday",
      function () {
        return require("private-next-pages/landing/win-a-yacht-holiday.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/win-a-yacht-holiday"])
      });
    }
  